export interface TokenData {
  token: string
  expiry: number
}

export class TokenService {
  static getTokenData(provider: string | undefined): TokenData | null {
    const key = provider ? `encrypted_llm_token_${provider}` : null;
    if (!key) return null;
    
    const data = localStorage.getItem(key);
    if (!data) return null;
    
    try {
      const parsed = JSON.parse(data);
      if (!parsed.token || !parsed.expiry) return null;
      
      if (Date.now() > parsed.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      
      return parsed;
    } catch {
      return null;
    }
  }

  static isTokenValid(tokenData: TokenData | null): boolean {
    if (!tokenData) return false;
    return Date.now() <= tokenData.expiry;
  }

  static clearExpiredToken(provider: string): void {
    const key = `encrypted_llm_token_${provider}`;
    localStorage.removeItem(key);
  }

  static getAuthHeaders(provider: string | undefined): Record<string, string> | undefined {
    const tokenData = this.getTokenData(provider);
    return tokenData?.token ? { "x-llm-token": tokenData.token } : undefined;
  }
} 